import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';
import { FaEdit, FaCoins, FaNotesMedical, FaUserCheck } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { fundApi } from '../../api/funds';
import { handleApiResponse } from '../global/ApiMessageModal/ApiMessageModal';

const HaririMchangoModal = ({ show, onHide, contribution, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    amount: '',
    description: '',
    received_by: ''
  });

  useEffect(() => {
    if (contribution) {
      setFormData({
        amount: contribution.amount_raw || '',
        description: contribution.description !== '-' ? contribution.description : '',
        received_by: contribution.received_by || ''
      });
    }
  }, [contribution]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!contribution?.id) return;
    if (!formData.amount || parseFloat(formData.amount) <= 0) {
      toast.warning('Tafadhali ingiza kiasi sahihi cha mchango');
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        amount: parseFloat(formData.amount),
        description: formData.description || null,
        received_by: formData.received_by || null
      };

      const response = await fundApi.updateFund(contribution.id, payload);
      if (handleApiResponse(response)) {
        toast.success('Mchango umebadilishwa kikamilifu!');
        onHide();
        if (onSuccess) onSuccess();
      }
    } catch (err) {
      console.error('Error updating fund:', err);
      handleApiResponse(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold d-flex align-items-center gap-2" style={{ color: '#4169e1' }}>
          <div className="p-2 rounded-3 bg-primary-subtle text-primary d-flex align-items-center justify-content-center">
            <FaEdit size={20} />
          </div>
          Hariri Mchango - {contribution?.full_name}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body className="p-4">
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">
              <FaCoins className="me-2 text-muted" />
              Kiasi Cha Mchango (TZS) <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              min="1"
              value={formData.amount}
              onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
              required
              className="rounded-3 shadow-none border py-2"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">
              <FaNotesMedical className="me-2 text-muted" />
              Maelezo ya Mchango
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className="rounded-3 shadow-none border"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">
              <FaUserCheck className="me-2 text-muted" />
              Mhifadhi / Aliyepokea
            </Form.Label>
            <Form.Control
              type="text"
              value={formData.received_by}
              onChange={(e) => setFormData({ ...formData, received_by: e.target.value })}
              className="rounded-3 shadow-none border py-2"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 px-4 pb-4">
          <Button variant="light" onClick={onHide} className="rounded-pill px-4 fw-medium border">
            Ghairi
          </Button>
          <Button
            type="submit"
            variant="primary"
            disabled={submitting}
            className="rounded-pill px-4 fw-semibold shadow-sm border-0"
            style={{ backgroundColor: '#4169e1' }}
          >
            {submitting ? (
              <><Spinner animation="border" size="sm" className="me-2" />Inahifadhi...</>
            ) : (
              'Hifadhi Mabadiliko'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default HaririMchangoModal;
